@if (formState | async; as state) {
<app-unauth-card>
  @if (!state.success) {
  <div>
    <h4>Enter your email address</h4>
    <form [formGroup]="form" (submit)="submit()">
      <mat-form-field>
        <mat-label>Email address or username</mat-label>
        <input matInput autofocus formControlName="email" required />
      </mat-form-field>
      @switch (state.loading) {
        @case (false) {
          <button mat-flat-button color="primary" class="m-t-30" [disabled]="form.invalid">
            Request Password Reset
          </button>
          <a mat-flat-button class="m-t-30" [routerLink]="['/login']">Cancel</a>
        }
        @case (true) {
          <button mat-flat-button color="primary" class="m-t-30" disabled>Please wait...</button>
        }
      }
      @if (state.error) {
      <mat-error>{{ state.error }}</mat-error>
      }
    </form>
  </div>
  }
  @if (state.success) {
  <div>
    <h4>Check your email!</h4>
    <p>
      We have sent you an email with the instructions for resetting your password.
    </p>
  </div>
  }
</app-unauth-card>
}
